import * as yup from 'yup';

export const passwordRecoverySchema = yup.object({
  password: yup
    .string()
    .min(8, "La contraseña debe tener al menos 8 caracteres")
    .required("La contraseña es obligatoria"),
  password2: yup
    .string()
    .oneOf([yup.ref('password'), null], "Las contraseñas deben coincidir")
    .required("Confirmar la contraseña es obligatorio"),
});